import React, { Component } from 'react'
import { toast } from 'react-toastify'
import { reduce } from 'libraries/lodash'
import cx from 'classnames'
import { switchMap, map } from 'rxjs/operators'
import ErrorIcon from '@material-ui/icons/Error'
import { EncryptionKeys, exportKey, exportKeys } from 'front-end-core/services/EncryptionService'
import notificationToast from 'helpers/notificationToast'
import { requestAllComments } from 'services/CommentsService'
import connect from 'components/shared/connect'
import PageHeader from '../PageHeader'
import ActionButton from './ActionButton'
import EncryptionKeyOverlay from './EncryptionKeyOverlay'
import EncryptionUrl from './EncryptionUrl'

@connect(
  EncryptionKeys.pipe(
    switchMap(
      encryptionKeys =>
        requestAllComments().pipe(map(x => x.entries), map(comments => ({ comments, encryptionKeys })))
    )
  )
)
class Encryption extends Component {
  handleOnClickExportKey = () => {
    if (this.props.browser.isIE) {
      alert('Please use a different browser to generate encryption keys')
    }

    exportKey().subscribe({
      error: ({ message }) => notificationToast(<ErrorIcon />, toast.TYPE.ERROR, message, 'bg-indian-red white')
    })
  }

  handleOnClickExportKeyList = () => {
    exportKeys().subscribe({
      error: ({ message }) => notificationToast(<ErrorIcon />, toast.TYPE.ERROR, message, 'bg-indian-red white')
    })
  }

  render () {
    const { encryptionKeys, comments, pageToggleOverlay, className } = this.props
    const errorsTotal = reduce(comments, (agg, c) => c.decryptionStatus === 'failed'
      ? agg + 1
      : agg, 0
    )
    return (
      <div className={cx(className, 'f5')}>
        <PageHeader title='Comment encryption settings' />
        <div className='flex flex-column'>
          {encryptionKeys && encryptionKeys.map((key, index) => (
            <EncryptionUrl
              url={key.uri}
              isValid={key.key !== null}
              key={key.urn}
              comments={comments}
              isPrimary={index === 0}
              even={index % 2 === 0}
            />
          ))}
          <p className='pv6 pv0 ph5'>Decryption Errors: {errorsTotal}</p>
        </div>
        <div className='account-actions'>
          <ActionButton
            label='Add key'
            className='bg-teal white hover-white pv3 ph5 ba b--transparent br2 normal f6 lh-copy-variant hover-o-90 mr4'
            onClick={() => pageToggleOverlay(<EncryptionKeyOverlay {...{ pageToggleOverlay }} />)}
          />
          <ActionButton
            className='bg-void-grey black pv3 ph5 ba b--transparent br2 normal f6 lh-copy-variant hover-bg-gains-boro mr4'
            icon='icon-key'
            label='New encryption key'
            onClick={this.handleOnClickExportKey}
            tooltip='Generate and download encryption key'
          />
          <ActionButton
            className='bg-void-grey black pv3 ph5 ba b--transparent br2 normal f6 lh-copy-variant hover-bg-gains-boro'
            icon='icon-key-change'
            label='Export key list'
            onClick={this.handleOnClickExportKeyList}
          />
        </div>
      </div>
    )
  }
}

export default Encryption
